import React from 'react';
import { compose } from 'recompose';
import { Subscribe, StoreProvider } from '../store';
import { JssProvider } from 'react-jss';

import withGlobalize from '../application/globalize/withGlobalize';
import withApplication from '../application/hoc/withApplication';
import withApplicationProvider from '../application/hoc/withApplicationProvider';
import ClientProvider from '../application/client/ClientProvider';
import SchengenZoneMap from './SchengenZoneMap';
import IsSchengen from '../components/IsSchengen/IsSchengen';
import { countries } from '../containers/CountriesContainer';

function SchengenZoneMapApp(props) {
  const { 
    generateClassName,
    host,
    application,
  } = props;
  const {
    language,
  } = application;

  return (
    <JssProvider generateClassName={generateClassName}>
      <ClientProvider host={host}>
        <StoreProvider>
          <Subscribe to={[countries]}>
            {(store) => {
              const { countries, error, isFetching } = store.state;
              if(!countries.length && !error && !isFetching) {
                store.fetchCountries(language);
              }
              return (
                <div class="padding-top50 padding-bottom50 pb-9 w-full mx-auto items-center bg-white">
                  <div class="items-center">
                    <IsSchengen language={language} />
                  </div>
                  <div class="hidden lg:block">
                    <SchengenZoneMap
                      store={store}
                      language={language}
                    />
                  </div>
                </div>
              );
            }}
          </Subscribe>
        </StoreProvider>
      </ClientProvider>
    </JssProvider>
  );
}

const SchengenZoneMapComposed = compose(
  withApplicationProvider(),
  withApplication(),
  withGlobalize(),
)(SchengenZoneMapApp);

export default SchengenZoneMapComposed;



// WEBPACK FOOTER //
// ./src/maps/SchengenZoneMapApp.js